module.exports = {
  "flex-row": {
    "flexDirection": "row"
  },
  "full-rest": {
    "flex": 1
  },
  "root": {
    "paddingTop": 28,
    "paddingBottom": 24,
    "backgroundColor": "#ffffff"
  },
  "title": {
    "height": 40,
    "paddingLeft": 70,
    "paddingRight": 70
  },
  "content": {
    "paddingTop": 9,
    "paddingBottom": 42,
    "paddingLeft": 70,
    "paddingRight": 70
  },
  "last-one-content": {
    "paddingBottom": 0
  },
  "line": {
    "position": "absolute",
    "top": 0,
    "bottom": 0,
    "left": 38,
    "width": 2,
    "backgroundColor": "#FFC300"
  },
  "first-one-title-line": {
    "top": 20
  },
  "last-one-title-line": {
    "bottom": 20
  },
  "last-one-content-line": {
    "width": 0
  },
  "point": {
    "position": "absolute",
    "top": 13,
    "left": 32,
    "width": 14,
    "height": 14,
    "backgroundColor": "#FFF0BD",
    "borderStyle": "solid",
    "borderWidth": 2,
    "borderColor": "#EE9900",
    "borderRadius": 100
  },
  "highlight-point": {
    "top": 7,
    "left": 26,
    "width": 26,
    "height": 26,
    "backgroundColor": "#EE9900",
    "borderStyle": "solid",
    "borderWidth": 6,
    "borderColor": "#FFE78D"
  },
  "text-title": {
    "fontSize": 30,
    "color": "#3d3d3d"
  },
  "text-highlight-title": {
    "color": "#EE9900"
  },
  "text-desc": {
    "fontSize": 24,
    "color": "#a5a5a5",
    "marginBottom": 12
  },
  "text-date": {
    "fontSize": 24,
    "color": "#a5a5a5"
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-6edf662d!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-simple-flow/index.vue
// module id = 175
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28